























import Vue from "vue";

export default Vue.extend({
    name: "ValidHint",
    props: {
        text: {
            type: String,
            default: ''
        },
        isCheck: {
            type: Boolean,
            default: true
        },
        isValid: {
            type: Boolean,
            default: true
        }
    }
})
